<template>
    <transition name="slide">
        <div v-if="visibility" class="slide-outer">
            <div class="slide-content">
                <div v-if="showBackPanel" class="back-row">
                    <div class="back-button" @click="$emit('close')">
                        <g-icon class="icon" name="chevron-left" />
                        <span class="text">Back</span>
                    </div>
                </div>
                <slot></slot>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: {
            visibility: {
                type:     Boolean,
                required: true,
            },
            showBackPanel: {
                type:    Boolean,
                default: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
.slide-outer {
    position: fixed;
    max-width: $g-screen-size-xs;
    margin: 0 auto;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    height: 100%;
    z-index: 1000;
    background-color: rgba(255, 255, 255, 0.2);
    overflow: hidden;
    .slide-content {
        position: absolute;
        background-color: white;
        width: 100%;
        bottom: 0;
        right: 0;
        left: 0;
        height: 100%;
        z-index: 10001;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        box-shadow: 0 0 5px 1px rgba(30, 30, 30, 0.3);
        overflow: hidden;
        overflow-y: auto;
        padding: 0 30px;
        .back-row {
            height: 100px;
            display: flex;
            align-items: center;
            .back-button {
                font-size: 14px;
                border: 1px $g-color-grey-3 solid;
                border-radius: 4px;
                display: flex;
                align-items: center;
                padding: 3px 10px 3px 7px;
                cursor: pointer;
                .icon {
                    font-size: 13px !important;
                }
                .text {
                    margin-left: 4px;
                }
            }
        }
    }
}

.slide-enter-active, .slide-leave-active {
    transition: all .4s;
}
.slide-enter, .slide-leave-to {
    opacity: 0;
    margin-top: 100%;
}
</style>